"use client";
import {
  DialogContextProvider
} from "../__chunks/IWHI6Y45.js";
import "../__chunks/RG6J4TID.js";
import "../__chunks/GUCZNEAD.js";
import {
  useDialogStore
} from "../__chunks/2KACNUKS.js";
import "../__chunks/ZIX5D53S.js";
import "../__chunks/PWUXK5IM.js";
import "../__chunks/WOWUAP42.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/dialog/dialog-provider.tsx
import { jsx } from "react/jsx-runtime";
function DialogProvider(props = {}) {
  const store = useDialogStore(props);
  return /* @__PURE__ */ jsx(DialogContextProvider, { value: store, children: props.children });
}
export {
  DialogProvider
};
